import { TimePeriod } from "./decode-iso-8601-duration-from-time-period";

export const convertTimePeriodToSeconds = (
  timePeriod?: TimePeriod,
): number => {
  if (!timePeriod || timePeriod.amount.length === 0) {
    return 0;
  }

  let totalSeconds = 0;

  for (let i = 0; i < timePeriod.amount.length; i++) {
    const amount = timePeriod.amount[i];
    const unit = timePeriod.time_unit[i];

    switch (unit) {
      case "weeks":
        totalSeconds += amount * 7 * 24 * 60 * 60;
        break;
      case "days":
        totalSeconds += amount * 24 * 60 * 60;
        break;
      case "hours":
        totalSeconds += amount * 60 * 60;
        break;
      case "minutes":
        totalSeconds += amount * 60;
        break;
      case "seconds":
        totalSeconds += amount;
        break;
    }
  }

  return totalSeconds;
};
